import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@pancakeswap-libs/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Oxanium', cursive;
  }
  body {
    background: url('/images/back.png');
    background-size: auto 100vh;
    background-attachment: fixed;
    ${({ theme }) => theme.mediaQueries.sm}{
      background-size: 100% 100vh ;
      background-attachment: fixed;
    }

    img {
      height: auto;
      max-width: 100%;
    }
  }
`

export default GlobalStyle
